import React, { useState} from 'react';
import { connect } from "react-redux";
import {
    CardBody,
    Col, Form, FormGroup, Label, Row,
} from 'reactstrap';
import {
    ButtonClean,
    ButtonSearch,
} from "../../../components/buttons/buttonsActions";
import Switch from "react-bootstrap-switch";
import {useForm} from "react-hook-form";
import {  FL_STATUS} from "../../../components/i18n/formLabels";
import {setFilter} from "../../../redux/actions/generics/IndexedActions";
import {getStateByPath} from "../../../redux/selectors";
import {useSelector} from "react-redux";


const ProgramFilters = (props) => {
    const path = props.path || 'atv/program';
    const componentState = useSelector(state => getStateByPath(state, path));
    const { filter } = componentState?.data || props.listProps || {};
    const { app } = componentState?.data || props.mainProps || {}

    const fbDataBaseId = app?.fbDataBase?.id
    const [status, setStatus] = useState( filter?.item?.status ?? null);

    // ----------------------------------------------
    //            CHANGE HANDLERS
    // ----------------------------------------------
    const statusChange = () => {
        setStatus(!status);
    };

    const cleanFields = () => {
        const tmpFilter = JSON.parse(JSON.stringify(filter))
        setStatus(null);
        props.setFilter(tmpFilter);
    }

    // ----------------------------------------------
    //            SEARCH FILTERS FORM
    // ----------------------------------------------
    const {register, handleSubmit, reset} = useForm({
        defaultValues: {
        }
    });

    const onSubmit = (data, _) => {
        if(!fbDataBaseId)
            return

        const dataFilter = {
            fbDataBase : {  id : fbDataBaseId },
            item : { }
        }

        if (status !== undefined && status !== null){
            dataFilter.item.status = status;
        }

    props.setFilter(path, dataFilter);
    };

    return (
        <Form onSubmit={handleSubmit(onSubmit)}>
            <CardBody className="">
                <Row>
                    <Col md="2">
                        <FormGroup>
                            <Label>{ FL_STATUS }</Label>
                            <br />
                            <Switch animate={true} offText={"No"} onText={"Si"}
                                    value={status}
                                    innerRef={register}
                                    onChange={statusChange}
                            />
                        </FormGroup>
                    </Col>
                </Row>
                <Row>
                    <Col md="12" className="d-flex justify-content-center">
                        <div className="float-right">
                            <ButtonSearch/>
                            <ButtonClean onClick={() => cleanFields()}/>
                        </div>
                    </Col>
                </Row>
            </CardBody>
        </Form>
    )
}

const mapStateToProps = state => ({
    mainProps: state.mainProps,
    listProps: state.listProps,
})

const mapActionsToProps = ({
    setFilter,
})

export default connect(mapStateToProps, mapActionsToProps)(ProgramFilters)
